import { render } from "./UncappedSearchFromPage.vue?vue&type=template&id=1b5257e4"
import script from "./UncappedSearchFromPage.vue?vue&type=script&lang=js"
export * from "./UncappedSearchFromPage.vue?vue&type=script&lang=js"

import "./UncappedSearchFromPage.vue?vue&type=style&index=0&id=1b5257e4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__